module.exports = __webpack_public_path__ + "img/default_header.441d7a84.png";